export default __webpack_public_path__ + "static/media/message.4a704ec7.svg";